import { t } from '@lingui/macro';
import React from 'react';
import { connect } from 'react-redux';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import * as V from '../../../constants/variables';
import { getStartFinishTrackColorScope } from '../../../utils/getStartFinishTrackColorScope';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { MultiGroupFilter } from '../MultiGroupFilter';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import styles from '../FilterSidebar.module.css';

const getTrackLabel = (isStartTrack, value, mode) => `≥ ${value} ${(mode === V.SHARE) || (mode === 'TANDEM_SHARE') ? '%' : isStartTrack ? t`стартов` : t`финишей`}`;
const StartFinishTrackFilterComponent = ({ startTrackDays, onChangeMapFilters, layer, finishTrackDays, startTrackMode, finishTrackMode }) => {
    const isStartTrack = layer.id === V.aggregatedStartTracks;
    const filterValue = isStartTrack ? startTrackDays : finishTrackDays;
    const activeMode = isStartTrack ? startTrackMode : finishTrackMode;
    const onChange = ({ target: { value } }) => {
        const key = isStartTrack ? 'startTrackDays' : 'finishTrackDays';
        onChangeMapFilters(key, +value);
    };
    const onChangeMode = mode => {
        const key = isStartTrack ? 'startTrackMode' : 'finishTrackMode';
        onChangeMapFilters(key, mode);
    };
    const filteredTrackModeOptions = V.trackModeOptions.filter(({ type }) => isStartTrack || (![ 'TANDEM', 'TANDEM_SHARE' ].includes(type)));
    const hexLegendItems = getStartFinishTrackColorScope(filterValue, activeMode)
        .map((value, index) => ({
            id: value,
            label: { id: `label_${value}`, message: getTrackLabel(isStartTrack, value, activeMode) },
            fill: V.startFinishTrackHexagonColor[index],
        }))
        .filter((_, index) => index !== 0);
    const hexLegendContent = (
        <ColoredItemsLegend
            items={hexLegendItems}
            icon={LEGEND_ICON_TYPES.HEXAGON}
            renderConfig={{
                showIcon: true,
                iconSize: '30px',
                iconOpacity: 0.8,
                fontSize: '0.85rem',
            }}
        />
    );
    return (
        <div>
            <div className={styles.legHead}>
                {t`Агрегированные`}
                {' '}
                {isStartTrack ? t`старты` : t`финиши`}
                {' '}
                {t`треков`}
                {':'}
            </div>

            <MultiGroupFilter
                isVisible={true}
                groups={[
                    {
                        id: 'mode',
                        type: 'button-group',
                        value: activeMode,
                        onChange: e => onChangeMode(e.target.value),
                        options: filteredTrackModeOptions.map(({ type, label }) => ({
                            value: type,
                            label,
                        })),
                    },
                    {
                        id: 'days',
                        value: String(filterValue),
                        onChange,
                        options: V.startFinishTrackFilterValues.map(value => ({
                            value,
                            label: t`${value} дней`,
                        })),
                    },
                ]}
                footer={hexLegendContent}
            />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { startTrackDays, finishTrackDays, startTrackMode, finishTrackMode } }) => ({
    startTrackDays, finishTrackDays, startTrackMode, finishTrackMode,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(StartFinishTrackFilterComponent);

export const StartTrackFilter = withDisplayedLayersCheck(ConnectedComponent, V.aggregatedStartTracks);
export const FinishTrackFilter = withDisplayedLayersCheck(ConnectedComponent, V.aggregatedFinishTracks);
